<template>
    <q-layout data-testid="report-manager" class="q-pa-lg">
        <q-card class="fit">
            <q-card-section class="q-py-xs">
                <div class="report-title">
                    {{reportTitle || name}}
                </div>
            </q-card-section>
            <q-card-section>
                <div class="row">
                    <JtDynamicForm
                        data-testid="form"
                        ref="form"
                        :inputs="form.inputs"
                        :model="form.dadosForm"
                        :relacionamentos="form.relacionamentos"
                        :interface="form.nmInterface"
                        @on-select-change="onSelectChangeHandler"/>
                </div>
            </q-card-section>
        </q-card>
        <div class="row full-width q-col-gutter-lg justify-center q-py-md">
            <div class="col-lg-2 col-md-3">
                <q-btn class="full-width" color="grey-7" @click="onClear">
                    {{ $gettext('CLEAN') }}
                </q-btn>
            </div>
            <div class="col-lg-2 col-md-3">
                <q-btn class="full-width" color="info" @click="openGridResiduesFilter">
                  {{ $gettext('RESIDUES_BUTTON') }}
                </q-btn>
            </div>
            <div class="col-lg-2 col-md-3">
                <q-btn class="full-width" color="info" @click="onGenerateReportClick">
                {{ $gettext('GENERATE') }}
                </q-btn>
            </div>
        </div>
        <JtDocsViewer
        :src="fileSrc"
        :title="reportTitle || name"
        :pdf="reportFormat.pdf"
        :xls="reportFormat.xls"
        ref="reportModal" />
    <q-dialog v-model="dadosModal.show" :maximized="true">
      <q-layout view="Lhh lpR fff" container class="bg-white modal-medium">
        <q-header class="bg-primary" >
          <q-toolbar>
            <q-toolbar-title>{{ $gettext('RESIDUE_REPORT') }}</q-toolbar-title>
            <q-btn v-close-popup flat round dense icon="close" />
          </q-toolbar>
        </q-header>
        <q-page-container style="max-height: 85vh" class="scroll" >
          <div class="container">
            <q-btn class="gerarBtn" color="info" @click="generateResiduesReport">
                  {{ $gettext('GENERATE_REPORT') }}
                </q-btn>
                <span class="dataSearchResidueReport">
                  <strong>{{ $gettext('PERIOD') }}: </strong>
                  {{ formatPeriod }}
                </span>
          </div>
          <jt-data-table
              v-if="nmInterface && datatable"
              ref="jtDataTable"
              class="table-crud"
              :buttons="datatable.buttons"
              :fields="datatable.columns"
              :nm-interface="nmInterface"
              multiselect
              selectionForce
              :extraParams="extraParams"
              :is-paginated="false"
              @selection="_event => onSelectRow(_event)"
            />
        </q-page-container>
      </q-layout>
    </q-dialog>
    </q-layout>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { JtDocsViewer } from 'jtech-webcomps/src/components/jtech-docs'
import { JtDynamicForm, JtDataTable } from 'jtech-webcomps'
import { repository, messageBox } from 'jtech'

@Component({
  name: 'WeighingReport',
  components: {
    JtDynamicForm,
    JtDocsViewer,
    JtDataTable
  },
  props: {
    forms: { type: Array, required: true }
  }
})
class WeighingReport extends Vue {
  fileSrc = null
  reportTitle = 'Relatório de Pesagens'
    dadosTelaFromRepository = []
    reportGenerationFormat = {
      online: true,
      scheduling: false
    }

    reportFormat = {
      pdf: false,
      xls: true
    }

  dadosModal = {
    show: false
  };

  extraParams = {}
  residuesRerpotData = {
    residues: []
  }

  get hasInitialAndFinalInput () {
    return this.initialInput && this.finalInput
  }

  get initialInput () {
    return this.form?.dadosForm?.inputInitial
  }

  get finalInput () {
    return this.form?.dadosForm?.inputFinal
  }

  get formatPeriod () {
    return `${this.$gettext('OF_UPPER_CASE')} ${this.initialInput} ${this.$gettext('TO_IN_UPPER_CASE')} ${this.finalInput}`
  }

  nmInterface = 'residueReport.pesquisarResidues'
  datatable = null

  get inputInitial () {
    return this.$refs.form?._props?.model?.inputInitial
  }

  get inputFinal () {
    return this.$refs.form?._props?.model?.inputFinal
  }

  onSelectRow (_event) {
    this.residuesRerpotData.residues = []
    _event.forEach(_selectedRecord => {
      this.residuesRerpotData.residues.push(_selectedRecord.id)
    })
  }

  async generateResiduesReport () {
    const params = this.residuesRerpotData
    if ((params.residues?.length || 0) == 0) {
      messageBox.error(this.$gettext('SELECT_ONE_RESIDUE'))
      return
    }
    const newParams = this.createParamsResidueReport(params)
    const reportData = await repository.resolveLogic('residueReport.residueReport', newParams)
    await this.__whenGenerationFormatIsOnline(reportData)
    this.reportTitle = 'Relatório de Pesagens'
  }

  createParamsResidueReport (params) {
    const newParams = { ...params }
    newParams.relFormaGeracao = 1
    newParams.relFormatoRelatorio = 3
    newParams.cdRelatorio = 'Relatatório por Resí­duo'
    this.reportTitle = 'Relatatório Por Resíduo'
    return newParams
  }

  async openGridResiduesFilter () {
    if (this.isValidDate) {
      messageBox.error(this.$gettext('DATA_INTERVAL_RESIDUE_REPORT'))
      return
    }
    const params = this.getInitialDataToResidueReport()
    this.residuesRerpotData = params
    const inputDate = new Date(this.parseDate(this.$refs.form._props.model.inputInitial, this.$refs.form._props.model.inputTimeInitial))
    const outputDate = new Date(this.parseDate(this.$refs.form._props.model.inputFinal, this.$refs.form._props.model.inputTimeFinal))
    if (outputDate < inputDate) {
      messageBox.error(this.$gettext('INIT_DATE_BIGGER_THAN_LAST_DATE'))
      return
    }
    this.extraParams = params
    this.datatable = await repository.resolveDatatable(this.nmInterface, this.extraParams)
    this.dadosModal.show = true
  }

  get isValidDate () {
    if (this.$refs.form._props.model.inputInitial == null || this.$refs.form._props.model.inputFinal == null ||
      this.$refs.form._props.model.inputFinal == '' || this.$refs.form._props.model.inputInitial == '') {
      return true
    } else {
      return false
    }
  }

  getInitialDataToResidueReport () {
    return {
      inputDate: this.$refs.form._props.model.inputInitial +
      (this.$refs.form._props.model.inputTimeInitial ? ' ' + this.$refs.form._props.model.inputTimeInitial : ' 00:00'),
      outputDate: this.$refs.form._props.model.inputFinal +
      (this.$refs.form._props.model.inputTimeFinal ? ' ' + this.$refs.form._props.model.inputTimeFinal : ' 23:59'),
      client: this.$refs.form._props.model.client
    }
  }

  parseDate (dateString, time) {
    if (time == null) {
      time = ''
    }

    if (!dateString) {
      return
    }
    const parts = dateString.split('/')
    const day = parseInt(parts[0], 10)
    const month = parseInt(parts[1], 10)
    const year = parseInt(parts[2], 10)
    return year + '/' + month + '/' + day + ' ' + time
  }

  onClear () {
    this.$refs.form.resetForm()
  }

  __getDisplayData () {
    return repository.resolve('weighingReport.weighingReport')
  }

  async beforeMount () {
    this.dadosTelaFromRepository = await this.__getDisplayData()
  }

  get form () {
    return this.dadosTelaFromRepository[0]
  }

  emitCloseToBus () {
    this.$emit('on-close', {})
  }

  get computedDadosTelaFromRepository () {
    return Array.isArray(this.dadosTelaFromRepository) &&
      this.dadosTelaFromRepository.length
      ? this.dadosTelaFromRepository[0]
      : {}
  }

  async __whenGenerationFormatIsOnline ({ nmArquivo }) {
    try {
      const result = await this.$jt.repository.downloadFile(
        nmArquivo,
        'xls',
        '',
        'application/xls'
      )

      this.fileSrc = URL.createObjectURL(result)
      this.$nextTick(() => {
        if (this.reportFormat.xls) {
          this.__downloadFile(this.fileSrc, this.reportTitle, '.xls')
          this.emitCloseToBus()
        } else {
          this.$refs.reportModal.show()
        }
      })
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  }

  __downloadFile (fileSrc, fileName = 'downloaded_file', extension = '.xls') {
    const link = document.createElement('a')
    link.style = 'display: none'
    link.download = `${fileName}${extension}`
    link.href = fileSrc
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  async onGenerateReportClick () {
    try {
      this.$emit('generate', {
        dadosForm: this.computedDadosTelaFromRepository.dadosForm,
        nmInterface: this.computedDadosTelaFromRepository.nmInterface
      })
      const resolveLogicResult = await this.$jt.repository.resolveLogic(
        this.computedDadosTelaFromRepository.nmInterface,
        this.computedDadosTelaFromRepository.dadosForm
      )
      await this.__whenGenerationFormatIsOnline(resolveLogicResult)
    } catch (error) {
      console.error(error)
    }
  }
}

export default WeighingReport
</script>

<style>
.report-title {
  font-weight: 500;
  font-size: 1.3em;
  margin-top: 5px;
  border-bottom: 1px solid #e0e0e0;
}
.container {
  display: flex;
  align-items: center;
}

.btn-container {
  margin-top: 30px;
}
.gerarBtn{
  margin: 0.5% 0 0.6% 18px;
}
.dataSearchResidueReport{
  text-align: center;
  font-size: 18px;
  flex: 1;
  margin-right: 10%;
}

</style>
